import { render, staticRenderFns } from "./benke.vue?vue&type=template&id=40dd4c1c&scoped=true"
import script from "./benke.vue?vue&type=script&lang=js"
export * from "./benke.vue?vue&type=script&lang=js"
import style0 from "./benke.vue?vue&type=style&index=0&id=40dd4c1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dd4c1c",
  null
  
)

export default component.exports